import { UserRoleIDEnum } from '@alluradirect/react';

// Computed Properties are now allowed in an enum. Therefore we cannot have a
// dyanmic root level enum.

export enum OwnerRoutesEnum {
  management = `/host/management`,
  onboarding = '/host/onboarding',
  dashboard = '/host/dashboard',
}

export enum OnboardingRoutesEnum {
  onboardingRequired = '/required',
  onboardingOptional = '/optional',
  guidebookWalkthrough = `/guidebookWalkthrough`,
  referralWalkthrough = '/referralWalkthrough',
  alluraUniversity = '/alluraUniversity',
  mobileWalkthrough = '/mobileWalkthrough',
}

export enum GuestRoutesEnum {
  home = '/guest',
  reviews = '/guest/reviews',
  booking = '/guest/booking',
  messages = '/guest/messages',
  payments = '/guest/payment',
  referrals = '/guest/referrals',
}

export const otherRoutes = {
  unauthorized: '/error/401',
  forbidden: 'error/403',
  notFound: 'error/404',
  error: '/error',
};

export const pid = 'pid';
export const dashboardPIDRoute = `${OwnerRoutesEnum.dashboard}/:${pid}`;
export const onboardingPIDRoute = `${OwnerRoutesEnum.onboarding}/:${pid}`;

export function calculateHomeRoute(userTypeId: UserRoleIDEnum): string {
  switch (userTypeId) {
    case UserRoleIDEnum.guest: {
      return GuestRoutesEnum.home;
    }

    case UserRoleIDEnum.owner: {
      return OwnerRoutesEnum.management;
    }

    case UserRoleIDEnum.propertyContact: {
      return OwnerRoutesEnum.management;
    }

    default: {
      return '';
    }
  }
}
